<template>
    <div class="user-menu" :class="{
        'rounded-lg py-6 ': $vuetify.display.mdAndUp,
        'user-menu--fixed bg-white px-8 overflow-auto': fixed,
        'pl-0': !fixed,
    }">
        <slot name="renderless" :active="active">
        </slot>
        <div class="d-flex justify-space-between mb-4" :class="{
            'pa-5 pb-2': $vuetify.display.smAndDown
        }">
            <div>
                <p class="text-h6 font-weight-bold">{{
                        $page.props.customer?.company || $page.props.customer.login
                    }}</p>
                <p class="text-tiny-link font-weight-light text-grey">{{$t('eshop::customer-layout.vip_dealer')}}</p>
            </div>
            <v-btn
                class="text-body-3 font-weight-thin text-decoration-underline mx-2"
                variant="text"
                @click="router.post(route('customer.logout'));store.forgetPrices();emit('closeMenu')"
            >
                <template #prepend>
                    <v-icon :icon="powerSettingsNew" class="align-self-center" size="12"></v-icon>
                </template>
                {{$t('eshop::customer-layout.logoff')}}
            </v-btn>
        </div>
        <v-divider></v-divider>
        <v-list class="pa-0" :class="{'bg-transparent': !fixed}">
            <template v-for="(m,i) in top" :key="i">
                <v-list-item
                    :active="m.active"
                    @click="go(m.link)"
                    class="pa-3"
                    :class="{'rounded-md': fixed}"
                    :active-class="!fixed ? 'c-active-menu' : ''"
                    density="comfortable"
                >
                    <template v-slot:prepend>
                        <v-icon :icon="m.icon" color="grey-lighten-1" size="24" class="mr-n4 opacity-100"></v-icon>
                    </template>
                    <v-list-item-title>
                        <p class="text-body-3 font-weight-bold">{{ m.title }}</p>
                    </v-list-item-title>
                </v-list-item>
            </template>
        </v-list>
        <v-divider></v-divider>
        <v-list class="pa-0" :class="{'bg-transparent': !fixed}">
            <template v-for="(m,i) in bottom" :key="i">
                <v-list-item
                    :active="m.active"
                    @click="go(m.link)"
                    class="pa-3"
                    :class="{'rounded-md': fixed}"
                    :active-class="!fixed ? 'c-active-menu' : ''"
                    density="comfortable"
                >
                    <template v-slot:prepend>
                        <v-icon :icon="m.icon" color="grey-lighten-1" size="24" class="mr-n4 opacity-100"></v-icon>
                    </template>
                    <v-list-item-title>
                        <p class="text-body-3">{{ m.title }}</p>
                    </v-list-item-title>
                </v-list-item>
            </template>
        </v-list>
    </div>
</template>
<script setup>
import {
    personApron,
    editNote,
    deployedCodeHistory,
    percent,
    listAlt,
    powerSettingsNew,
    settings,
    save
} from "../../../assets/icons/icons";
import {computed, inject, watch} from "vue";
import {router, usePage} from "@inertiajs/vue3";
import {trans} from "laravel-vue-i18n";
import { usePriceStore } from '../../../motonet/modules/eshop/stores/price.js';
import pinia from '../../../plugins/pinia.js';

const route = inject('route');
const store = usePriceStore(pinia);

const props = defineProps({
    fixed: {
        type: Boolean,
        default: true,
    },
    mobileMenu: {
        type: Boolean,
        default: false,
    },
})

const menuItems = computed(() => {
    usePage().url;
    return [
        {
            icon: personApron,
            title: trans('eshop::customer-layout.dashboard'),
            top: true,
            link: route('customer.dashboard'),
            active: route().current('customer.dashboard'),
        },
        {
            icon: listAlt,
            title: trans('eshop::customer-layout.orders'),
            top: true,
            link: route('customer.orders'),
            active: route().current('customer.orders') || route().current('customer.order'),
        }, {
            icon: deployedCodeHistory,
            title: trans('eshop::customer-layout.not_delivered'),
            top: true,
            link: route('customer.notDelivered'),
            active: route().current('customer.notDelivered'),
        },/*{
        icon: receiptLong,
        title: "Doklady",
        top: true,
        link: '',
        active: false,
    },*/{
            icon: percent,
            title: trans('eshop::customer-layout.fidelity'),
            top: true,
            link: route('customer.loyalty'),
            active: route().current('customer.loyalty'),
        }, {
            icon: editNote,
            title: trans('eshop::customer-layout.info'),
            top: true,
            link: route('customer.addresses'),
            active: route().current('customer.addresses'),
        }, {
            icon: settings,
            title: trans('eshop::customer-layout.settings'),
            top: true,
            link: route('customer.settings'),
            active: route().current('customer.settings'),
        },/*{
        icon: soundDetectionDogBarking,
        title: "Hlídací psi",
        top: true,
        link: '',
        active: false,
    },
        {
            icon: garageHome,
            title: "Moje garáž",
            top: false,
            link: '',
            active: false,
        },*/
        {
            icon: save,
            title: trans('app-bar.saved_products'),
            top: false,
            link: route('customer.shopping-lists'),
            active: route().current('customer.shopping-lists') || route().current('customer.shopping-list'),
        }
    ]
})
const active = computed(() => {
    return menuItems.value.find((item) => item.active)
})

const top = computed(() => {
    return menuItems.value.filter((item) => item.top)
})
const bottom = computed(() => {
    return menuItems.value.filter((item) => !item.top)
})
const emit = defineEmits(['closeMenu', 'activeChanged']);

if (props.mobileMenu) {
    watch(active, (val) => {
        emit('activeChanged', val);
    }, {immediate: true})
}
const go = (where) => {
    router.visit(where);
    emit('closeMenu')
}
</script>
<style scoped lang="scss">
@use '../../../plugins/vuetify-settings' as *;
@use 'vuetify/lib/styles/settings/variables' as *;
@use 'sass:map';
.user-menu--fixed {
    width: 400px;
    @media #{map.get($display-breakpoints, 'sm-and-down')}{
        width: 100vw;
        position: fixed;
        top: 35px;
        left: -12px;
    }
}

.v-list-item {
    &:hover {
        .v-list-item-title {
            p {
                color: map.get($orange, 'base');
                text-decoration: underline;
            }
        }

        .v-icon {
            color: map.get($orange, 'base') !important;
        }
    }
}

:deep(.c-active-menu) {
    background-color: white;
    border-left: 2px solid map.get($orange, base);

    > .v-list-item__overlay {
        opacity: 0;
    }

    > .v-list-item__prepend {
        .v-icon {
            color: map.get($orange, base) !important;
        }
    }
}
</style>
